import { Map } from 'immutable';
import {
  types as jobTypes,
  records as jobRecords,
} from '@saucelabs/sl-module-jobs';

import { INITIALIZE, UPDATE } from './types';

const initialState = Map({
  job: new jobRecords.JobRecord(),
  loading: true,
  pageIndex: 0,
  shouldCallInit: true,
});

const containerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case INITIALIZE.REQUEST:
      return state.set('loading', true);
    case INITIALIZE.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('loading', false);
      });
    case UPDATE.PAGE_INDEX:
      return state.set('pageIndex', payload);
    case UPDATE.SHOULD_CALL_INIT:
      return state.set('shouldCallInit', payload);
    case jobTypes.JOB_GET.SUCCESS:
      return state.set('job', new jobRecords.JobRecord(payload));
    case jobTypes.UP_JOB_GET.SUCCESS:
      return state.set('job', new jobRecords.RdcJobRecord(payload));
    default:
      return state;
  }
};

export default containerReducer;
export { initialState };
